import axios from 'axios'

const getCurrentQuiz = async () => {
  try {
    let response = await axios.get('https://www.bayern3.radio/pdd/quizzes/current')
    return response.data
  } catch (error) {
    console.error("ERROR", error) 
    return null
  }
}

const getRandomPastQuiz = async () => {
  try {
    let response = await axios.get('https://www.bayern3.radio/pdd/quizzes/random')
    return response.data
  } catch (error) {
    console.error("ERROR", error) 
    return null
  }
}

export {
  getCurrentQuiz, getRandomPastQuiz
} 